import React, { memo, useEffect, useMemo, useState } from "react";
import { Link } from "gatsby";
import { ReactSVG } from "react-svg";
import logo from "@images/impressit-logo.svg";
import "./Header.scss";
import useWindowDimensions from "@hooks/useWindowDimensions";
import { TABLET_MAX_WIDTH } from "@constants";
import NavLinks from "./NavLinks/NavLinks";
import BurgerMenu from "./BurgerMenu/BurgerMenu";

const isWindowAvailable = typeof window !== "undefined";

const Header = ({
    headerTitle = (
        <p>
            Welcome to <strong>impressit</strong>
        </p>
    ),
    showLinks,
    handleClick,
    headerPosition,
    openMobileFilters,
    setOpenMobileFilters,
    path,
}) => {
    const { width } = useWindowDimensions();
    const [didMount, setDidMount] = useState(false);

    useEffect(() => {
        setDidMount(true);
        return () => setDidMount(false);
    }, []);

    const isDesktop = useMemo(() => width > TABLET_MAX_WIDTH, [width]);

    if (isWindowAvailable && didMount) {
        /*  eslint-disable */
        if (
            location.pathname === "/blog" ||
            location.pathname.includes("/blog")
        ) {
            headerTitle = (
                <p>
                    Learn with <strong>impressit</strong>
                </p>
            );
        }
        /* eslint-enable */
    }

    if (!isDesktop) {
        return (
            <BurgerMenu
                handleClick={handleClick}
                showLinks={showLinks}
                headerTitle={headerTitle}
                width={width}
                openMobileFilters={openMobileFilters}
                setOpenMobileFilters={setOpenMobileFilters}
            />
        );
    }
    return (
        <header className="header" style={{
            top: `${headerPosition}px`
        }}>
            <div className="header__container">
                <div className="header__logo-link-container">
                    <Link to="/" className="header__logo-link">
                        <ReactSVG
                            src={logo}
                            alt="Impressit logo"
                            className="header__logo-icon"
                        />
                    </Link>
                    <span className="header__text-container">
                        {headerTitle}
                    </span>
                </div>
                <NavLinks path={path} />
            </div>
        </header>
    );
};

export default memo(Header);
